export enum DragResizeDirection {
	BOTTOM = 'bottom',
	LEFT = 'left',
	RIGHT = 'right',
	TOP = 'top',
}

export enum Axis {
	X = 'X',
	Y = 'Y',
}

export enum ClientPosition {
	X = 'clientX',
	Y = 'clientY',
}

export enum ClientDimension {
	X = 'clientWidth',
	Y = 'clientHeight',
}

export enum ScrollDimension {
	X = 'scrollWidth',
	Y = 'scrollHeight',
}

export enum OffsetDimension {
	X = 'offsetWidth',
	Y = 'offsetHeight',
}

export const DRAG_RESIZE_DEFAULT_DIRECTION = DragResizeDirection.LEFT;
